import { useState } from 'react';
import { Button } from '@accure/ui';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/modules/siteview/components/ui/card';

import { ResetPassword } from '../mutations';

export function ResetPasswordSection() {
  const [resetPasswordButtonText, setResetPasswordButtonText] =
    useState('Reset Password');
  const resetPassword = ResetPassword.useMutation();

  const handleResetPasswordClick = async () => {
    try {
      setResetPasswordButtonText('Redirecting...');
      const result = await resetPassword.mutateAsync();
      window.open(result.passwordResetUrl, '_blank');
    } catch (error) {
      console.error('Failed to reset password:', error);
    } finally {
      setTimeout(() => {
        setResetPasswordButtonText('Reset Password');
      }, 3000);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Reset Password</CardTitle>
        <CardDescription>
          Change your account password securely through Auth0
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button
          variant="primaryOutline"
          data-testid="reset-password-button"
          onClick={handleResetPasswordClick}
        >
          {resetPasswordButtonText}
        </Button>
        <p className="text-sm text-muted-foreground">
          You will be redirected to a secure page to reset your password
        </p>
      </CardContent>
    </Card>
  );
}
